import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios' 
import ElementUI from 'element-ui'
import vant from 'vant'
import 'animate.css'
import qs from 'qs'
Vue.prototype.$qs = qs;

import "swiper/css/swiper.min.css"
import "element-ui/lib/theme-chalk/index.css"
import "vant/lib/index.css"
import "./assets/js/device.js"

import rootUrl from './components/global.vue'

Vue.prototype.rootUrl = rootUrl.rootUrl; //接口路径

Vue.use(ElementUI,axios,vant);

axios.defaults.withCredentials = true; // session传值
Vue.config.productionTip = false;

Object.defineProperty(Vue.prototype,'axios',{value:axios});
axios.defaults.baseURL = rootUrl.rootUrl; //接口路径


router.beforeEach((to,from,next) =>{
    if (to.matched.length === 0) {
        next('/errorPage') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    }
    next() 
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


